import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { SlimLoadingBarService } from "ng2-slim-loading-bar";
import swal from "sweetalert2";
import { environment } from "../../../environments/environment";
import { ErrorHandlerService } from "../../services/shared/error-handler.service";
import { UserServiceService } from "../../services/user-service/user-service.service";
import { ReservationService } from "../../services/reservation-service/reservation.service";

@Component({
  selector: "app-add-store-bank",
  templateUrl: "./add-store-bank.component.html",
  styleUrls: ["./add-store-bank.component.css"],
})
export class AddStoreBankComponent implements OnInit {
  //#region Definitions
  bank_export_url: any;
  title: string = "Add Bank";
  add_bank: any = {
    name: "",
    type: "",
    account_number: "",
    currency_id: null,
  };
  bankTypes = ["Bank", "Treasury", "Other"];
  bankId: any;
  isEditState = false;
  bank: any;
  developers: any[] = [];
  //#region

  current_bank: any;
  currencies_list: any[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserServiceService,
    private reservationService: ReservationService,
    private errorHandlerService: ErrorHandlerService,
    private slimLoadingBarService: SlimLoadingBarService,
  ) {}

  ngOnInit() {
    this.getDevelopers();
    this.getAllCurrencies();
    this.bank_export_url = `${
      environment.api_base_url
    }store_banks/export?token=${window.localStorage.getItem("token")}`;
    this.bankId = +this.route.snapshot.params["id"];
    if (this.bankId > 0) {
      this.isEditState = true;
      this.title = "Edit Bank";
      this.getBank(this.bankId);
    }
  }

  getAllCurrencies() {
    this.reservationService.getAllCurrencies().subscribe(
      (data: any) => {
        this.currencies_list = data;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getDevelopers() {
    this.userService.getDevelopers().subscribe(
      (res: any) => {
        this.developers = res;
      },
      (err) => this.errorHandlerService.handleErorr(err)
    );
  }

  getBank(id?) {
    this.current_bank = JSON.parse(window.localStorage.getItem("current_bank"));
    this.add_bank = {
      name: this.current_bank.name,
      type: this.current_bank.type || "",
      account_number: this.current_bank.account_number,
      currency_id: this.current_bank.currency_id,
      developer_id: this.current_bank.developer_id,
      id: this.current_bank.id,
    };
  }

  addBank() {
    this.slimLoadingBarService.start();
    let serUrl;
    if (this.add_bank && this.add_bank.id) {
      serUrl = this.userService.editBank(this.add_bank.id, this.add_bank);
    } else {
      serUrl = this.userService.addBank(this.add_bank);
    }
    console.log(serUrl);
    serUrl.subscribe(
      (data) => {
        swal("Added Bank successfully", "", "success");
        this.add_bank = {
          name: "",
          type: "",
          account_number: "",
          developer_id: "",
          currency_id: null,
        };
        this.router.navigateByUrl("/pages/settings/store_banks");
      },
      (err) => this.errorHandlerService.handleErorr(err),
      () => this.slimLoadingBarService.complete()
    );
  }

  ngOnDestroy() {
    this.current_bank = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/main-settings/add-store-bank/add-store-bank.component.ts